import { render, staticRenderFns } from "./UserStatistics.vue?vue&type=template&id=97c99f3a&"
import script from "./UserStatistics.vue?vue&type=script&lang=js&"
export * from "./UserStatistics.vue?vue&type=script&lang=js&"
import style0 from "./UserStatistics.vue?vue&type=style&index=0&id=97c99f3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports